<!-- Here we display the answers -->
<div class="main-container background-img" [style.background-image]="'url('+backgroundImg+')'">
  <div class="container pl-md-0">
    <div class="row pt-3">
      <div class="col col-md-8" *ngFor="let advisor of advisor">
        <a [routerLink]="['/', this.translate.currentLang, 'advisor',advisor.name]" (click)="quiz.answers = []">
          <img [src]="logo | translate" class="ipc-logo" alt="ipc logo">
        </a>
      </div>
      <div class="col col-md-4 col-lang">
        <label for="" *ngIf="multiLang === true" >
          <button class="lang-btn" (click)="this.changeLang('en')">EN</button>
          <button class="lang-btn" (click)="this.changeLang('fr')">FR</button>
        </label>
      </div> 
    </div>
  </div>
  <div class="container mb-5 pl-md-0 mt-5 mt-md-5 pt-0 pt-md-5">
    <div class="row">
      <div class="col-md-8 col-xl-6" *ngFor="let advisor of advisor">
        <h2 style="white-space: pre-line">{{quizResponse}}</h2>
        <p class="contact-buttons">
          <span *ngIf="advisor && !answerIcon" >
            <a [href]="advisor.page" class="btn btn-outline-primary btn-spacing connect-btn" target="_blank">{{connectBtn}}</a>
          </span>
          <span>
            <!-- A button allows us to start the quiz over, and a click event resets the user answers -->
            <a [routerLink]="['/', this.translate.currentLang, 'advisor',advisor.name]" class="btn btn-outline-primary btn-restart mr-3"
              (click)="quiz.answers = []">{{restartBtn}}</a>
          </span>
        </p>
        <p>
          <a class="p-0 answers-dropdown" data-toggle="collapse" data-target="#navbarTogglerDemo03"
            aria-controls="navbarTogglerDemo03" aria-expanded="false" aria-label="Toggle navigation" (click)="toggle()">
            {{viewList}} <span class="toogle-icon">{{toogleIcon}}</span>
          </a>
        </p>

        <div class="collapse justify-content-end navbar-collapse" [ngClass]="{ 'show': isShown }"
          id="navbarTogglerDemo03">
          <ng-container *ngFor="let answer of quiz.answers; let i = index;">
            <p><strong>{{questionTitle}} :</strong> {{ answer.question }}</p><br>
            <p><strong>{{answerTitle}} :</strong> {{ answer.answer }}</p><br>
            <p></p>
          </ng-container>
        </div>

      </div>
    </div>
  </div>
</div>
<footer class="footer">
  <div class="container pl-md-0">
    <div class="row">
      <div class="col-md-12 top-footer-text mt-4 text-center">
        <!-- <h3 class="font-weight-bold">HEAD OFFICE</h3>
        <p>5015 Spectrum Way. Mississauga, ON. Canada</p>
        <p>Phone: <a class="top-footer-text" href="tel:905-212-9799">905-212-9799</a></p>
        <hr class="footer-hr"> -->
        <p class="bottom-footer-text">© 2020 <a class="bottom-footer-text" href="https://www.ipcc.ca"
            target="_blank">Investment Planning
            Counsel</a></p>
      </div>
    </div>
  </div>
</footer>